
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="currentColor">
  <path d="M7.4375 3.60498H6.5625V7.54248C6.5625 7.66323 6.6115 7.77261 6.69069 7.85223L9.31569 10.4768L9.93431 9.85817L7.4375 7.36136V3.60498Z"/>
  <path d="M7 12.5007C4.10506 12.5007 1.75 10.1457 1.75 7.25073C1.75 4.35579 4.10506 2.00073 7 2.00073C9.89494 2.00073 12.25 4.35579 12.25 7.25073C12.25 10.1457 9.89494 12.5007 7 12.5007ZM7 1.12573C3.61725 1.12573 0.875 3.86798 0.875 7.25073C0.875 10.6335 3.61725 13.3757 7 13.3757C10.3827 13.3757 13.125 10.6335 13.125 7.25073C13.125 3.86798 10.3827 1.12573 7 1.12573Z"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ClockLine',
    }) as DefineComponent
    </script>
    